export default __webpack_public_path__ + "static/media/lock-icon.6918c50c.svg";